module.exports = __webpack_public_path__ + "assets/img/kv-643f51d4.jpg";